import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createIsomorphicFn } from "@tanstack/react-start";
import ms from "ms";

const clientStaleTime = ms("10 minutes");
const serverStaleTime = ms("10 seconds");
const serverGcTime = serverStaleTime;
const clientGcTime = Infinity;
const createQueryClient = createIsomorphicFn()
  .client(() => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          networkMode: "always",
          gcTime: clientGcTime,
          staleTime: clientStaleTime,
        },
      },
    });
    return queryClient;
  })
  .server(() => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          gcTime: serverGcTime,
          staleTime: serverStaleTime,
        },
      },
    });
    return queryClient;
  });
export function getContext() {
  const queryClient = createQueryClient();
  return {
    queryClient,
  };
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode;
  queryClient: QueryClient;
}) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
